import { trackFunnel } from './analytics';
export interface NumberProvenance {
  version: string; title:string; explanation:string;
  facts: {factId:string;label:string;value:number;systemLabel:string;sourceType:string;calculationTrace:string[];role:string;numberType:string}[];
}
export function NumberTrace({trace,role,onOpen}:{trace:string[];role?:string;onOpen?:()=>void}) {
  return <details className="number-trace" onToggle={event=>{if(event.currentTarget.open)onOpen?.();}}>
    <summary>Как посчитано</summary>
    <div className="number-trace-content">{trace.map((line,index)=><p key={index}>{line}</p>)}{role&&<p className="number-trace-role">{role}</p>}</div>
  </details>;
}
export function IntroNumberProvenance({provenance}:{provenance:NumberProvenance|null|undefined}) {
  if(!provenance?.facts.length)return null;
  const primary=provenance.facts.filter(f=>!f.factId.startsWith('classical.timeline.'));
  const timeline=provenance.facts.filter(f=>f.factId.startsWith('classical.timeline.'));
  const rows=(facts:NumberProvenance['facts'])=><ul>{facts.map(f=><li key={f.factId}>
      <div className="number-provenance-head"><div><small>{f.systemLabel}</small><h3>{f.label}</h3></div><span>{f.value}</span></div>
      <p className="number-provenance-source">{f.sourceType==='BIRTH_DATE_DERIVED'?'Рассчитано по всей дате рождения':f.sourceType==='CURRENT_CYCLE_DERIVED'?'Рассчитано для периода этого разбора':f.sourceType==='MATRIX22_DERIVED'?'Рассчитано по схеме Матрицы 22':'Из даты рождения'}</p>
      <NumberTrace trace={f.calculationTrace} role={f.role} onOpen={()=>void trackFunnel('intro_number_trace_opened',{numberType:f.numberType,sourceSurface:'introductory_reading'})}/>
    </li>)}</ul>;
  return <section className="reading-card intro-number-provenance" data-testid="intro-number-provenance">
    <h2>{provenance.title}</h2><p className="number-trust-copy">{provenance.explanation}</p>
    {rows(primary)}
    {timeline.length>0&&<details className="number-trace timeline-number-traces"><summary>Числа ближайших месяцев</summary>{rows(timeline)}</details>}
  </section>;
}
export function SectionProvenance({path,provenance,sections}:{path:string;provenance:NumberProvenance|null|undefined;sections:{path:string;factIds:string[]}[]|undefined}) {
  const ids=sections?.find(s=>s.path===path)?.factIds??[];
  const facts=provenance?.facts.filter(f=>ids.includes(f.factId))??[];
  if(!facts.length)return null;
  return <p className="section-provenance">На чём основан этот вывод: {facts.map(f=>`${f.label} ${f.value}`).join(' · ')}</p>;
}
